module.exports = __webpack_public_path__ + "static/media/1POLICY14.3060c368.jpg";